import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import "./ResultPage.css";
import person2 from "../../Assets/Frame 583 (1).png";
import { FaArrowLeft } from "react-icons/fa";
// import { CareerPAth } from "../CareerPath/CareerPAth";
import Cookies from "js-cookie";
import { resultSelector, selectedLang, testResult } from "../../utils/recoil";
import { useRecoilState, useRecoilValue } from "recoil";
import { log } from "debug";
import config from "../../config";
import energyimage from "../../Assets/Frame 583 (1).png";
import feelingsimage from "../../Assets/Frame 583 (2).png";
import mindimage from "../../Assets/Frame 583 (2).png";
import judgingimage from "../../Assets/Frame 583 (4).png";
import { languagesCode } from "../../utils/data";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import Loader from "../Loader/Loader";
import DetailedResultPreviewModal from "../../Pages/DetailedResultPage/DetailedResultPreviewModal";
import PaymentRequiredPopup from "./PaymentRequiredPopup";

 const staticTestResult = {
    id: "1",
    prediction: {
      mbti: {
        entity: {
          id: 1, // 8
          name: "campaigner",
          code: "ENFP",
        },
        values: {
          INTROVERT: "40.0%",
          SENSING: "44.0%",
          PROSPECTING: "58.0%",
          INTUITION: "56.0%",
          JUDGING: "42.0%",
          THINKING: "30.0%",
          FEELING: "70.0%",
          EXTROVERT: "60.0%",
        },
      },
      holland: {
        hollandCode: "RIS",
        entity: {
          id: 1,
          name: "realistic",
          code: "R",
        },
        values: {
          SOCIAL: "0.0%",
          CONVENTIONAL: "0.0%",
          INVESTIGATIVE: "17.0%",
          ENTERPRISING: "0.0%",
          REALISTIC: "83.0%",
          ARTISTIC: "0.0%",
        },
      },
    },
    holland_code_id: "1",
    mbti_type_id: "8",
    name: "Visionary Doer",
    simple_desc:
      "Visionary Doers are individuals who possess the imaginative and enthusiastic qualities coupled with the practical and resourceful nature of a realistic personality. They excel in creatively solving problems with innovative solutions while also ensuring their ideas are grounded in practicality and feasibility.",
    image_urls:
      "https://i.ibb.co/1dWcCyp/Firefly-3d-charecter-CEO-3d-icon-blender-colourful-green-isolated-background-s-750-v-6-0-509.png",
    voice_summary:
      "The test results indicate that you belong to the Visionary Doer category-someone who combines creativity, enthusiasm, and practicality to bring innovative ideas to life. You think outside the box, dream big, and work with a reality-based, hands-on approach, often inspiring others with uplifting energy and loyal support. You empathize with others’ problems and offer practical solutions, excelling in both creative fields such as writing, cinema, journalism, graphic design, teaching, and counseling, as well as practical domains like engineering, architecture, skilled trades, construction, agriculture, craftsmanship, and machinery operation. Your strengths include boundless energy, resilience, adaptability, problem-solving skills, leadership presence, physical endurance, and a joyful, present-focused mindset. You thrive in varied environments, adapt well to change, and bring a positive influence wherever you work. You enjoy new challenges, can quickly generate ideas, and work with determination to turn them into results. Your natural optimism makes you encouraging to others, and your resilience helps you recover quickly from setbacks. However, you may sometimes overthink, procrastinate, feel discomfort from criticism or conflict, struggle with routine tasks, and resist sudden changes. You prefer stability and hands-on work over lengthy theoretical discussions. While you collaborate well, there may be moments when teamwork or communication could be improved to build stronger relationships. In the workplace, you are a creative contributor who enjoys variety and thrives in fast-paced environments. You collaborate effectively, listen to others’ input, and combine ideas to create innovative solutions. Your communication is clear and practical, often focusing on results rather than unnecessary details. You adapt easily to changing circumstances and excel in roles that require both physical effort and mental creativity. Academically, you do best when learning is interactive, hands-on, and connected to real-life applications. You are motivated by subjects that allow you to explore ideas creatively while producing tangible results. You tend to prefer group projects where ideas can be exchanged, though you also work well independently when passionate about the topic. You are well-suited for careers that blend innovation, action, and human connection. Ideal creative roles include writing, filmmaking, journalism, graphic design, teaching, and counseling. Practical and technical careers may involve engineering, architecture, skilled trades, construction, agriculture, and machinery operation. You may also excel in public relations, marketing, non-profits, social justice work, event management, military, police, or fire services. Roles in palliative care, human resources, and education also align well with your strengths. Your leadership presence makes you capable of motivating teams and managing projects from start to finish. In entrepreneurial roles, you can spot opportunities, design innovative solutions, and execute plans with determination. In community-focused work, your empathy and energy make you a strong advocate for people and causes you believe in. Your adaptability allows you to shift smoothly between planning and action, while your problem-solving skills help you find practical ways to overcome obstacles. You are often seen as someone who 'makes things happen,'combining creative vision with the discipline to bring ideas to life. In relationships, you are loyal, supportive, and uplifting. You value meaningful connections and often go out of your way to help others achieve their goals. Your positive energy makes you enjoyable to be around, and your practical advice is often appreciated by friends, family, and colleagues. While you can be highly independent, you also value collaboration and shared achievements. For continued growth, you may benefit from strategies to manage overthinking and procrastination, such as breaking large tasks into smaller steps or setting clear deadlines. Building tolerance for constructive criticism can also strengthen your personal and professional relationships. Overall, as a Visionary Doer, you are a rare combination of dreamer and action-taker-someone who imagines possibilities and has the drive to turn them into reality. Whether in creative, technical, or service-oriented roles, your ability to inspire, innovate, and deliver results ensures you can make a lasting and meaningful impact wherever you choose to contribute.",
    motto: "Big ideas, bold actions, and real change.",
    overview:
      "You’re a creative thinker who also loves to take action. You dream of exciting possibilities and then bring those ideas to life through real, hands-on work. You enjoy solving real-world problems in unique ways. You care deeply about people and progress, and you're not afraid to get your hands dirty to make things better.",
    strength_overview: [
      {
        title: "Action-Oriented Creativity",
        description:
          "You don’t just dream, you build. You like turning ideas into real things.",
      },
      {
        title: "Emotional Drive",
        description:
          "You care a lot, and that passion pushes you to work hard for people and causes.",
      },
      {
        title: "Flexible Thinking",
        description:
          "You can change your plans easily and find new ways to solve problems.",
      },
      {
        title: "Motivating Energy",
        description:
          "You inspire others to join you with your enthusiasm and boldness.",
      },
      {
        title: "Hands-On Problem Solving",
        description:
          "You like fixing things yourself, whether it’s a machine or a system.",
      },
      {
        title: "Curiosity with Purpose",
        description:
          "You want to know how things work, especially if it helps someone.",
      },
      {
        title: "Creative Confidence",
        description:
          "You trust your instincts and love to create your way of doing things.",
      },
    ],
    figures: {
      description:
        "You’re inspired by people who take big ideas and make them real, especially when their work helps others or improves the world. These figures blend imagination with action, creativity with usefulness, just like you aim to do in everything you build.",
      celebrities: [
        {
          name: "Elon Musk",
          description:
            "A bold innovator who turns vision into practical tools and systems. He shows how combining imagination with action can create world-changing results, just like you aim to do.",
          image: "/uploads/figures/elon_musk.png",
        },
        {
          name: "Richard Branson",
          description:
            "A passionate entrepreneur who combines people-focused with adventure. His fearless attitude and people-first mindset mirror your love for building bold ideas that serve others.",
          image: "/uploads/figures/richard_branson.png",
        },
        {
          name: "Jamie Oliver",
          description:
            "A hands-on chef who mixes creativity, health, and real-world change. He uses practical skills and personality to educate and uplift, much like your mission-driven energy.",
          image: "/uploads/figures/jamie_oliver.png",
        },
        {
          name: "Temple Grandin",
          description:
            "A practical problem-solver who rethinks systems with empathy and design. Her ability to understand how systems affect people and improve them reflects your purpose-led innovation.",
          image: "/uploads/figures/temple_grandin.png",
        },
        {
          name: "Shigeru Miyamoto",
          description:
            "A playful inventor who created new ways for people to learn and have fun. His mix of creativity and function mirrors how you bring both fun and usefulness into your work.",
          image: "/uploads/figures/shigeru_miyamoto.png",
        },
        {
          name: "Boyan Slat",
          description:
            "A young inventor tackling environmental issues with courage and action. He proves that age doesn’t limit impact, a reminder that your ideas can lead real change, even now.",
          image: "/uploads/figures/boyan_slat.png",
        },
      ],
    },
    interests: {
      description:
        "You love work that blends real-world action with creative problem-solving.",
      areas: [
        {
          title: "Creative Technology",
          description:
            "You enjoy using tools, tech, or systems to bring ideas to life in practical ways.",
          percentage: "92",
        },
        {
          title: "Sustainable Innovation",
          description:
            "You care about creating things that last and make a difference.",
          percentage: "87",
        },
        {
          title: "Hands-On Learning & Repair",
          description:
            "You like working with your hands and seeing how things function.",
          percentage: "76",
        },
        {
          title: "Social Impact Projects",
          description:
            "You’re driven by purpose and enjoy working on real problems that affect others. ",
          percentage: "71",
        },
      ],
    },
    workfit: [
      {
        title: "Build-and-Do Mindset",
        description: "You need work where you get to make something real.",
      },
      {
        title: "Quick to Adapt",
        description: "You shift gears fast when something doesn’t work.",
      },
      {
        title: "Mission-Driven",
        description:
          "You want work that matters to people and makes a difference.",
      },
      {
        title: "Positive Energy",
        description: "You bring passion to teams and keep people going.",
      },
      {
        title: "Freedom to Act",
        description: "You like choosing how you get things done.",
      },
      {
        title: "People-and-Tools Balance",
        description: "You enjoy both teamwork and working with tools.",
      },
      {
        title: "Meaningful Challenge",
        description:
          "You stay engaged when the work feels exciting and useful.",
      },
    ],
    studyfit: [
      {
        title: "Project-Based Learning",
        description: "You learn best by doing real projects.",
      },
      {
        title: "Freedom to Explore",
        description: "You prefer open-ended assignments over strict routines.",
      },
      {
        title: "Fast Starter",
        description:
          "You get excited at the beginning of a task and bring lots of ideas.",
      },
      {
        title: "Emotional Interest",
        description:
          "You study harder when the topic feels personal or helpful to others.",
      },
      {
        title: "Visual Learning",
        description: "You remember better with videos, diagrams, or tools.",
      },
      {
        title: "Collaborative Thinking",
        description: "You like learning in groups where everyone shares ideas.",
      },
      {
        title: "Learning by Doing",
        description: "You need to try things out to fully understand them.",
      },
    ],
    books: [
      {
        title: "The Power of Now",
        author: "Eckhart Tolle",
        description:
          "Teaches how to focus on the moment and take action with clarity. This book helps you stay grounded when your thoughts race ahead, reminding you that impact starts now.",
        image: "/uploads/books/the_power_of_now.png",
      },
      {
        title: "Steal Like an Artist",
        author: "Austin Kleon",
        description:
          "Encourages creative thinking by mixing ideas and making them your own. It helps you trust your originality, even when you're borrowing or remixing what inspires you.",
        image: "/uploads/books/steal_like_an_artist.png",
      },
      {
        title: "Start Something That Matters",
        author: "Blake Mycoskie",
        description:
          " A guide to creating real impact through business and purpose. It shows how even small actions, when rooted in passion, can grow into something powerful.",
        image: "/uploads/books/start_something_that_matters.png",
      },
      {
        title: "Creative Confidence",
        author: "Tom & David Kelley",
        description:
          "Helps you unlock your ideas and turn them into real-world solutions. This book gives you tools to move from “what if” to “what’s next,” fueling your inner builder.",
        image: "/uploads/books/creative_confidence.png",
      },
      {
        title: "Atomic Habits",
        author: "James Clear",
        description:
          "Shows how small changes lead to big results, perfect for your goal-driven energy. It reminds you that daily progress, not just big dreams, creates the most lasting success.",
        image: "/uploads/books/atomic_habits.png",
      },
      {
        title: "Grit",
        author: "Angela Duckworth",
        description:
          "Encourages sticking with your ideas and finishing what you start. This book strengthens your ability to push through distractions and see your bold vision through to completion.",
        image: "/uploads/books/grit.png",
      },
    ],
    paths: [
      {
        title: "Stay Grounded",
        description:
          "Your dreams are big, keep your feet on the ground by taking small steps.",
      },
      {
        title: "Focus Your Fire",
        description:
          "Don’t chase every idea. Pick one and give it your full energy.",
      },
      {
        title: "Rest is Power Too",
        description:
          "Pause when you need to. You don’t have to move 24/7 to succeed.",
      },
      {
        title: "Talk Less, Build More",
        description:
          "Share your ideas after you’ve tested them. Let actions speak.",
      },
      {
        title: "Trust the Process",
        description:
          "Even when you don’t see results right away, keep showing up.",
      },
      {
        title: "Ask for Help",
        description:
          "You don’t have to fix everything alone. Collaboration can make you stronger.",
      },
      {
        title: "Balance Vision with Execution",
        description: "Make sure you finish as many ideas as you start.",
      },
    ],
    quote: "Build boldly. Act with heart. Start where you are.",
    strengths: [
      {
        title: "Inventive Thinking",
        description:
          "You come up with exciting, practical ideas for tough problems. You’re able to mix creativity with logic, finding unique solutions others often overlook.",
      },
      {
        title: "Empathy with Action",
        description:
          "You care deeply about people and take steps to help them. You don’t just feel,  you do, turning compassion into direct support.",
      },
      {
        title: "Motivating Energy",
        description:
          "You inspire others to keep going when things get tough. Your enthusiasm is contagious, often becoming the spark that moves a team forward.",
      },
      {
        title: "Quick Adaption",
        description:
          "You think fast and change plans easily if something’s not working. You don’t panic under pressure; you pivot and find a better route.",
      },
      {
        title: "Creative Leadership",
        description:
          "You take the lead by sharing bold visions and real solutions. People trust your direction because you combine imagination with follow-through.",
      },
      {
        title: "Hands-On Drive",
        description:
          "You prefer learning by building, testing, and fixing things yourself. You enjoy the process of figuring things out with your own hands, not just reading about it.",
      },
      {
        title: "Purposeful Curiosity",
        description:
          "You’re always asking how things work and how to make them better. You dive deep into learning when you believe it could lead to meaningful change.",
      },
    ],
    challenges: [
      {
        title: "Scattered Focus",
        description:
          "You may jump between too many ideas and struggle to finish. Your excitement can pull you in many directions before anything is fully completed.",
      },
      {
        title: "Overexcitement",
        description:
          "You sometimes commit before thinking things through. It’s easy to say “yes” in the moment, only to feel overwhelmed later.",
      },
      {
        title: "Restless Energy",
        description:
          "Sitting still or following strict rules can feel frustrating. You may become distracted or bored if things move too slowly or lack hands-on work.",
      },
      {
        title: "Fear of Structure",
        description:
          "You might resist schedules or systems that could actually help you. Routine can feel limiting, even when it’s the very thing that gives your ideas stability.",
      },
      {
        title: "Impatience with Slow Progress",
        description:
          "You want fast results and may give up too soon. When things take longer than expected, you might doubt yourself or the process.",
      },
      {
        title: "Burnout from Doing Too Much",
        description:
          "You try to help or build too much at once and wear yourself out. You care so much that you push past your limits, until exhaustion hits hard.",
      },
      {
        title: "Under planning",
        description:
          "You trust your instincts, but sometimes forget to plan ahead. You rely on your energy in the moment, which can backfire when tasks get complex.",
      },
    ],
    challenge_solutions: [
      {
        title: "If you're losing focus",
        description:
          "Choose one project and give it your best before starting another.",
      },
      {
        title: "If you overcommit",
        description:
          "Slow down and ask, 'Do I really have time for this right now?'",
      },
      {
        title: "If you're feeling restless",
        description: "Break tasks into smaller actions so you can keep moving.",
      },
      {
        title: "If you resist structure",
        description:
          "Try building flexible routines, structure doesn’t mean control.",
      },
      {
        title: "If you’re burning out",
        description: "Schedule breaks the same way you schedule work.",
      },
      {
        title: "If you get frustrated with progress",
        description: "Remind yourself that real change takes time.",
      },
      {
        title: "If you forget to plan",
        description:
          "Spend 10 minutes mapping your next steps, it saves you hours later.",
      },
    ],
    closing_tip:
      "You’re here to do things differently, just remember: finishing is part of dreaming too.",
    career_path: {
      description:
        "You are a builder of ideas and a doer with heart. You thrive in roles where you can take action, express creativity, and create meaningful results, all while helping people and solving real-world problems. Whether you're using tools, words, or innovation, your best work happens when your hands and your purpose are both fully engaged.",
      paths: [
        {
          title: "Writer / Filmmaker / Journalist",
          description:
            "You express powerful ideas through stories, visuals, and communication that spark change. These creative paths let you inspire others and bring your imagination to life in tangible ways.",
        },
        {
          title: "Counselor / Therapist / Social Worker",
          description:
            "You connect deeply with people and offer support through life’s challenges. These careers use your empathy and problem-solving to make a lasting difference.",
        },
        {
          title: "Teacher / Educator / Educational Consultant",
          description:
            "You love sharing knowledge in creative, people-first ways. You're at your best when you're helping others grow and learn in fun, engaging environments.",
        },
        {
          title: "Human Resources Manager / Recruiter",
          description:
            "You build better workplaces through relationships, hiring, and conflict resolution. Your understanding of people helps teams thrive and feel supported.",
        },
        {
          title: "Entrepreneur / Startup Founder",
          description:
            "You enjoy starting new things and bringing bold ideas into the real world. These roles give you freedom, creative control, and the chance to lead with impact.",
        },
        {
          title:
            "Public Relations Specialist / Marketing Executive / Social Media Manager",
          description:
            "You communicate with passion and clarity, helping people understand and connect with ideas. These fields let you use both creativity and influence to shape perception.",
        },
        {
          title: "Nonprofit Program Director / Advocacy Coordinator",
          description:
            "You fight for causes you believe in by leading programs, building awareness, and organizing action. These roles combine leadership, compassion, and real-world impact.",
        },
        {
          title: "Event Planner / Coordinator",
          description:
            "You enjoy organizing memorable events and bringing people together. These careers use your people skills, attention to detail, and ability to manage fast-moving tasks.",
        },
        {
          title: "Skilled Tradesperson",
          description:
            "You like working with tools and seeing immediate, useful results from your hands-on efforts. These careers give you freedom, practical learning, and tangible outcomes.",
        },
        {
          title: "Automotive Technician / Engineer",
          description:
            "You enjoy solving technical problems and understanding how machines work. These roles let you be both precise and hands-on, fixing or designing systems that matter.",
        },
        {
          title: "Construction Manager / Mason / HVAC Technician",
          description:
            "You’re skilled at managing tools, teams, and time to get real things built. You find pride in turning plans into structures and solving issues along the way.",
        },
        {
          title: "Mechanical / Civil / Electrical Engineer",
          description:
            "You bring creative thinking and logic to systems, machines, or infrastructure. These fields challenge your brain while still offering real-world, visible results.",
        },
        {
          title: "Machinist / Equipment Operator / Production Technician",
          description:
            "You prefer active, skill-based work that involves tools and machinery. These roles allow you to build, move, or fix things in high-impact industries.",
        },
        {
          title: "Firefighter / Emergency Medical Technician",
          description:
            "You stay calm in crisis and act fast when others need help. These careers match your courage, compassion, and need to make a direct difference.",
        },
        {
          title: "Military / Law Enforcement / Security Services",
          description:
            "You’re committed to protecting and serving through structure, skill, and teamwork. These paths give you a strong mission, clear roles, and real-world challenges.",
        },
        {
          title: "Forestry / Conservation / Environmental Technician",
          description:
            "You enjoy being outdoors and working to protect natural spaces. These careers let you combine care for the earth with practical, hands-on tasks.",
        },
        {
          title: "Agricultural Technician / Sustainable Farming Specialist",
          description:
            "You enjoy working with your hands in nature, growing solutions that feed and sustain life. These roles offer purpose, movement, and visible rewards for your effort.",
        },
      ],
    },
    workplace_habit: {
      introduction:
        "You bring energy, innovation, and a 'let’s try it' mindset into any work environment. You prefer hands-on tasks, flexible routines, and opportunities to build something meaningful. You work best when given freedom and trust, and you thrive when your ideas can quickly become action.",
      habits: [
        {
          title: "Your Collaboration Style",
          description:
            "You enjoy working with people who are open, energetic, and ready to try new things. You often spark fresh ideas during team conversations and encourage others to take bold steps.",
          example:
            "During a brainstorming session, you throw out a big idea, get others excited, and then help the team break it into doable parts.",
        },
        {
          title: "Your Communication Style",
          description:
            "You speak with passion, using stories or vivid examples to explain what you mean. You're good at rallying others and making them believe in the work you're doing together.",
          example:
            "In a team meeting, you say, 'I know this idea seems ambitious, but if we start small, we can actually make it happen.'",
        },
        {
          title: "Your Work Behavior",
          description:
            "You prefer fast-moving tasks that let you stay busy and engaged. You dislike micromanagement and often create your own way to complete work, as long as the goal is clear.",
          example:
            "When given a new project, you map out a creative path forward, then dive in and adapt as you go.",
        },
        {
          title: "Your Emotional Sensitivity",
          description:
            "You're emotionally tuned in to your coworkers and care about how everyone’s doing. You often check in with people or lift the mood when things feel tense.",
          example:
            "When someone on the team seems quiet or overwhelmed, you ask if they’re okay and offer to take a task off their plate.",
        },
      ],
      work_culture: [
        {
          title: "Flexible Schedules",
          description: "Freedom to manage your time and flow.",
        },
        {
          title: "Open Communication",
          description:
            "A space where people share honestly and ideas are welcomed.",
        },
        {
          title: "Creative Problem Solving",
          description:
            "Encouragement to try new methods and think outside the box.",
        },
        {
          title: "Team Energy",
          description:
            "Positive, collaborative people who bring enthusiasm to work.",
        },
        {
          title: "Purposeful Projects",
          description: "Work that connects to a real goal or impact.",
        },
        {
          title: "Autonomy & Trust",
          description: "You’re trusted to do things your own way.",
        },
        {
          title: "Fast Feedback Loops",
          description: "You get quick responses and clear progress.",
        },
      ],
    },
    academic_habit: {
      introduction:
        "You are an active learner who enjoys doing, experimenting, and solving real-life problems. You thrive in environments where you can explore big ideas, connect them to real tasks, and take action quickly. You’re most focused when learning feels useful, meaningful, or hands-on.",
      habits: [
        {
          title: "Your Collaboration Style",
          description:
            "You like group projects where everyone brings different strengths to the table. You often help energize the group and encourage everyone to get moving.",
          example:
            "In a science project, you're the one suggesting a creative experiment and assigning quick action steps to the group.",
        },
        {
          title: "Your Communication Style",
          description:
            "You explain things in your own creative way, often using examples, comparisons, or quick sketches. You like class discussions where ideas bounce around freely.",
          example:
            "During a debate, you say, 'Think of it like this…' and paint a picture that makes your side easier to understand.",
        },
        {
          title: "Your Study Behavior",
          description:
            "You dislike boring, repetitive study methods. You learn better when you can move, build, watch, or explain things to someone else.",
          example:
            "Instead of reading a long chapter, you watch a video summary and then create a visual mind map of the topic.",
        },
        {
          title: "Your Emotional Sensitivity",
          description:
            "You often sense how classmates or teachers are feeling. You try to create a comfortable space for others to learn, and you reach out when someone seems down.",
          example:
            "When a group member is nervous about presenting, you offer to go first or co-present to help them feel more confident.",
        },
      ],
      academic_culture: [
        {
          title: "Project-Based Learning",
          description: "Classes focus on building or testing real things.",
        },
        {
          title: "Freedom in Assignments",
          description: "You’re allowed to choose how to express your learning.",
        },
        {
          title: "Hands-On Practice",
          description: "Labs, tools, and real-world examples are used often.",
        },
        {
          title: "Encouraging Teachers",
          description: "Instructors are supportive, clear, and motivational.",
        },
        {
          title: "Open Discussions",
          description: "Students are encouraged to share ideas freely.",
        },
        {
          title: "Real-Life Relevance",
          description: "Topics are connected to real careers or global issues.",
        },
        {
          title: "Flexible Deadlines",
          description:
            "There's room to adjust based on progress and creativity.",
        },
      ],
    },
    relationships: {
      introduction:
        "You bring passion, warmth, and bold support into your relationships. You care deeply and love fully, often acting with big gestures or thoughtful surprises. You build bonds through shared experiences, heartfelt conversations, and a desire to help others grow. While you're expressive and fun-loving, you also need space to recharge and stay focused on your own goals.",
      strengths: {
        data: [
          {
            title: "Loyal Support",
            description:
              "You stand by the people you care about, especially during tough times.",
          },
          {
            title: "Emotional Encouragement",
            description:
              "You lift others up with positive words and real action.",
          },
          {
            title: "Spontaneous Affection",
            description:
              "You show love through surprise gestures, fun plans, or heartfelt moments.",
          },
          {
            title: "Growth-Oriented Love",
            description:
              "You help people believe in themselves and push them to improve.",
          },
          {
            title: "Adventurous Bonding",
            description:
              "You enjoy exploring new places, ideas, or hobbies with loved ones.",
          },
          {
            title: "Deep Conversation",
            description: "You connect through honest, meaningful talks.",
          },
        ],
        example:
          "When your friend is feeling lost about their goals, you cheer them on with excitement, send them a voice note full of encouragement, and offer to brainstorm ideas over a spontaneous cafe hangout.",
      },
      struggle: {
        data: [
          {
            title: "Overgiving",
            description:
              "You sometimes do too much for others and forget to care for yourself.",
          },
          {
            title: "Emotional Overload",
            description:
              "You feel deeply, which can lead to overwhelm during conflict or stress.",
          },
          {
            title: "Restlessness",
            description:
              "You may struggle with routines or long-term commitments if they feel too limiting.",
          },
          {
            title: "Avoiding Conflict",
            description:
              "You try to keep things positive, which can lead to unspoken issues.",
          },
          {
            title: "Inconsistency",
            description:
              "Your mood or attention may shift quickly, which can confuse others.",
          },
          {
            title: "High Expectations",
            description:
              "You may idealize people, then feel disappointed when reality sets in.",
          },
        ],
        example:
          "When someone close to you makes a mistake, you might smile and act like everything’s okay, but later feel emotionally drained because you never got to say how you really felt.",
      },
      dynamics: [
        {
          description:
            "You may give more than you receive and feel emotionally drained.",
        },
        {
          description:
            "You alternate between intense closeness and needing lots of space.",
        },
        {
          description:
            "You expect others to read your feelings without clearly expressing them.",
        },
        {
          description:
            "You form deep connections quickly, sometimes before truly knowing someone.",
        },
        {
          description: "You may pull away when things feel too steady or slow.",
        },
      ],
    },
    learning_style: {
      introduction:
        "You learn best through action, curiosity, and purpose. If something feels important, exciting, or creative, you're all in. You don’t like being told to memorize facts without understanding why they matter. You grow most when your learning is hands-on, people-centered, and connected to the real world.",
      data: [
        {
          title: "Preferred Learning Methods",
          description:
            "You learn by exploring, testing, and expressing ideas through real-life examples. You prefer active, flexible learning over repetition or routine.",
          example:
            "Instead of reading a manual, you prefer jumping into a project, trying things out, and learning from your mistakes.",
        },
        {
          title: "Emotional Connection to Learning",
          description:
            "You need to feel connected to the topic in order to care. Emotion, inspiration, and meaning all help you stay focused.",
          example:
            "In a health class, you become passionate about a unit on nutrition when it connects to your family’s lifestyle and real habits.",
        },
        {
          title: "Reflective Processing",
          description:
            "You often reflect out loud or through creativity. Your insights come through talking, writing, or sketching your way through the material.",
          example:
            "After a tough assignment, you talk it out with a friend, realizing what worked, and what you’d do differently next time.",
        },
        {
          title: "Growth-Oriented Mindset",
          description:
            "You believe learning should lead to action. You’re not afraid to fail, as long as you're moving forward.",
          example:
            "When a science project doesn’t go as planned, you get excited about fixing it instead of feeling defeated.",
        },
      ],
    },
    conclusion:
      "You are a powerful mix of energy, empathy, and action. As a Visionary Doer, you dream big, but more importantly, you build. You want to create things that matter, help people grow, and explore the world with purpose. Your learning is active, your leadership is creative, and your heart is always behind what you do. When you stay focused, take care of yourself, and follow through on your best ideas, there’s nothing you can’t accomplish.",
    concluding_quote:
      "Your vision is bold, but it's your action that makes it real.",
  };

const ResultPage = () => {
  const _testResult = useRecoilValue(resultSelector) || staticTestResult;

  const [count, setCount] = useState(0);
  const [resultPage, setResultPage] = useState(false);
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });
  const usernameCookie = Cookies.get("username", {
    domain: config.cookieDomain,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [resultdata, setResultData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isPaymentPopupOpen, setIsPaymentPopupOpen] = useState(false);
  const [isPreviewPopupOpen, setIsPreviewPopupOpen] = useState(false);

  console.log(_testResult, "testt");
  useEffect(() => {
    // console.log(isPaidCookie, tokenCookie);
    if (tokenCookie) {
    // if (isPaidCookie && (isPaidCookie === 'ROLE_UNPAID_USER')) navigate({ pathname: '/home', search: location.search });
    // if (isTestTaken && isTestTaken === "FALSE")
    //   navigate({ pathname: "/home", search: location.search });
    } else {
      window.location.href = config.domain + '/login';
    }
  }, []);

  useEffect(() => {
    const energy = [];
    const feelings = [];
    const judging = [];
    const mind = [];

    const energyKeys = ["EXTROVERT", "INTROVERT"];
    const feelingsKeys = ["FEELING", "THINKING"];
    const judgingKeys = ["PROSPECTING", "JUDGING"];
    const mindKeys = ["SENSING", "INTUITION"];

    const traitNames = {
      E: "Extroverted",
      I: "Introverted",
      N: "Intuition",
      S: "Sensing",
      F: "Feeling",
      T: "Thinking",
      P: "Prospecting",
      J: "Judging",
    };

    _testResult &&
      _testResult?.prediction?.mbti?.values &&
      Object.keys(_testResult?.prediction?.mbti?.values).map((key) => {
        if (energyKeys.includes(key)) {
          energy.push({
            name: key,
            value: parseInt(
              _testResult?.prediction?.mbti?.values[key].split(".")[0],
            ),
          });
        }
        if (feelingsKeys.includes(key)) {
          feelings.push({
            name: key,
            value: parseInt(
              _testResult?.prediction?.mbti?.values[key].split(".")[0],
            ),
          });
        }
        if (mindKeys.includes(key)) {
          mind.push({
            name: key,
            value: parseInt(
              _testResult?.prediction?.mbti?.values[key].split(".")[0],
            ),
          });
        }
        if (judgingKeys.includes(key)) {
          judging.push({
            name: key,
            value: parseInt(
              _testResult?.prediction?.mbti?.values[key].split(".")[0],
            ),
          });
        }
      });
    // console.log(energy);
    const resultImages = _testResult?.image_urls?.split(",")
      ? _testResult?.image_urls?.split(",")
      : [];
    setResultData([
      {
        image: resultImages[0] ? resultImages[0] : energyimage,
        description: _testResult.simpleDesc,
      },
      {
        image: resultImages[0] ? resultImages[0] : energyimage,
        title: "ENERGY",
        type: traitNames[_testResult?.prediction?.mbti?.entity?.code[0]],
        typeValue: 52,
        typecatagory: energy,
        description:
          "Extraversion and Introversion represent two distinct ways of engaging with the world: one through outward exploration and interaction, and the other through inward reflection and introspection.",
      },
      {
        image: resultImages[1] ? resultImages[1] : mindimage,
        title: "MIND",
        type: traitNames[_testResult?.prediction?.mbti?.entity?.code[1]],
        typeValue: 52,
        typecatagory: mind,
        description:
          "These two preferences represent different ways of perceiving and processing information, with Sensing focusing on the here and now, while Intuition looks to the future and explores broader patterns and possibilities.",
      },
      {
        title: "FEELING",
        image: resultImages[2] ? resultImages[2] : feelingsimage,
        type: traitNames[_testResult?.prediction?.mbti?.entity?.code[2]],
        typeValue: 52,
        typecatagory: feelings,
        description:
          "Individuals who prefer Feeling prioritize personal values and empathy in decision-making, while those who prefer Thinking prioritize logic and rationality. Both traits contribute to diverse perspectives and approaches to problem-solving in different situations.",
      },
      {
        image: resultImages[3] ? resultImages[3] : judgingimage,
        title: "JUDGING",
        type: traitNames[_testResult?.prediction?.mbti?.entity?.code[3]],
        typeValue: 52,
        typecatagory: judging,
        description:
          "These traits represent different ways in which individuals approach and interact with the external world, influencing their decision-making processes, planning styles, and overall lifestyle preferences.",
      },
    ]);
  }, [_testResult]);

  console.log(resultdata, "resssz");

  const showPopup = () => {
    setIsPaymentPopupOpen(true);
  };

  const nextButton = () => {
    if (count < resultdata?.length - 1) {
      setCount(count + 1);
    } else {
      navigate({ pathname: "/my_profile", search: location.search });
      // showPopup();
      // if (isPaidCookie && isPaidCookie === "ROLE_UNPAID_USER") {
      //   navigate('/home');
      // } else {
      // navigate({ pathname: '/detail_result_page', search: location.search });
      // }
    }
  };

  const closePaymentPopup = () => {
    setIsPaymentPopupOpen(false);
  };

  const closePreviewPopup = () => {
    setIsPreviewPopupOpen(false);
  };

  const proceedToPayment = () => {
    navigate("/home");
  };

  const showPreviewPopup = () => {
    setIsPaymentPopupOpen(false);
    setIsPreviewPopupOpen(true);
  };

  const backButton = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };
  console.log(count);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const length = resultdata?.length;

  return (
    <>
      <Layout>
        {loader ? (
          <Loader setIsLoading={setLoader} />
        ) : (
          <React.Suspense fallback={<LoadingPage />}>
            <div className="energy-main">
              <div className="energy-main-box">
                <div className="energy-image">
                  <img src={resultdata[count]?.image} alt="" />
                </div>
                <div className="energy-content">
                  <div className="above-section">
                    <div className="above-section-child">
                      {count === 0 ? (
                        <>
                          <h3 className="second-heading">
                            your personality type is
                          </h3>
                          <h4>{_testResult.name}</h4>
                        </>
                      ) : (
                        <>
                          <h1>{resultdata[count]?.title}</h1>
                          <h2>{resultdata[count]?.type}</h2>

                          <div className="percentege-box">
                            <div
                              className="percentage-boxenergy-1"
                              style={{
                                width: `${resultdata[count]?.typecatagory[0]?.value}%`,
                              }}
                            ></div>
                            <div
                              className="percentage-boxenergy-2"
                              style={{
                                width: `${resultdata[count]?.typecatagory[1]?.value}%`,
                              }}
                            ></div>
                          </div>

                          <div className="percentage-numaric">
                            <div className="numaric-first">
                              <p>
                                {resultdata[count]?.typecatagory[0]?.value}%
                              </p>
                              <p>{resultdata[count]?.typecatagory[0]?.name}</p>
                            </div>
                            <div className="numaric-second">
                              <p>
                                {resultdata[count]?.typecatagory[1]?.value}%
                              </p>
                              <p>{resultdata[count]?.typecatagory[1]?.name}</p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <p
                      className=""
                      style={{
                        fontSize: "1.3rem",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                    >
                      {resultdata[count]?.description}
                    </p>
                  </div>
                  <div className="belowsection">
                    <div className="below-back-section">
                      {count !== 0 && (
                        <button onClick={backButton} className="first-back">
                          <FaArrowLeft />
                          Back
                        </button>
                      )}
                      {(count !== length || count === 0) && (
                        <button
                          onClick={nextButton}
                          className={`first-next ${count === 0 ? "centered-button" : ""}`}
                        >
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Suspense>
        )}
      </Layout>
      {isPaymentPopupOpen && (
        <PaymentRequiredPopup
          onClose={closePaymentPopup}
          onProceedToPayment={proceedToPayment}
          onShowPreview={showPreviewPopup}
        />
      )}
      {isPreviewPopupOpen && (
        <DetailedResultPreviewModal onClose={closePreviewPopup} />
      )}
      {/* {resultPage && <CareerPAth />} */}
    </>
  );
};

export default ResultPage;
